import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import Page from 'components/Page';
import styled from '@emotion/styled';
import SearchBars from 'components/SearchBars';
import Sticky from 'react-stickynode';
import SearchBarWrapper from 'components/SearchBarWrapper';
import ServiceAgreementsTable, {
  SERVICE_AGREEMENT_COLUMNS, SERVICE_AGREEMENT_CARDS, SERVICE_AGREEMENT_MIN_TABLE_WIDTH,
} from 'components/Tables/ServiceAgreements';
import * as DataList from 'components/DataList';
import ClientsSideBar from 'components/Client/ClientsSideBar';

// Same frame as the Clients index, which shares this sidebar.
const PageWrapGray = styled('div')`
  padding: 5px 5px 0px 5px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'viewStore', 'serviceAgreementStore') @observer
class ServiceAgreementsIndex extends Component {

  get canRender() {
    let {
      serviceAgreementStore: {
        serviceAgreements: {
          isLoading,
          isError,
          objects
        }
      }
    } = this.props;
    return (!isLoading && !isError && objects);
  }

  render() {
    let content;
    let {
      serviceAgreementStore: {
        serviceAgreements: {
          isLoading,
          isError,
          objects
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={SERVICE_AGREEMENT_COLUMNS}
          cards={SERVICE_AGREEMENT_CARDS}
          minTableWidth={SERVICE_AGREEMENT_MIN_TABLE_WIDTH}
          noun="service agreements"
        />
      );
    }
    if (isError && !isLoading) {
      content = (
        <DataList.LoadError
          noun="service agreements"
          onRetry={() => this.props.serviceAgreementStore.loadServiceAgreements()}
        />
      );
    }
    if (this.canRender) {
      content = <ServiceAgreementsTable />
    }
    return(
      <div>
        <Helmet>
          <title>Service Agreements | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters"> 
          <div className="col-lg-2  sidebar-responsive">
            <ClientsSideBar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBarWrapper>
                  <SearchBars.ServiceAgreement key={this.props.viewStore.listFiltersVersion} />
                </SearchBarWrapper>
              </Sticky>

              <Page style={{ paddingTop: 0 }}>
                {content}
              </Page>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }

};

export default ServiceAgreementsIndex;